const TERMINAL_STATUSES = new Set([
  "completed",
  "closed",
  "rejected",
  "cancelled",
]);

export function isHandlingTimerTerminal(status) {
  return TERMINAL_STATUSES.has(String(status || "").trim().toLowerCase());
}

/**
 * @returns {number|null} elapsed ms, or null if start is missing/invalid
 */
export function getHandlingElapsedMs({
  startedAt,
  endedAt,
  nowMs = Date.now(),
  terminal = false,
}) {
  const start = Date.parse(startedAt);
  if (!Number.isFinite(start)) return null;
  let end = nowMs;
  if (terminal) {
    const closed = Date.parse(endedAt);
    end = Number.isFinite(closed) ? closed : nowMs;
  }
  return Math.max(0, end - start);
}

/** Format as H:MM:SS or D:HH:MM:SS for long handles. */
export function formatHandlingElapsed(ms) {
  const totalSec = Math.floor(Math.max(0, Number(ms) || 0) / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;
  const pad = (n) => String(n).padStart(2, "0");
  if (days > 0) {
    return `${days}י ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }
  return `${hours}:${pad(minutes)}:${pad(seconds)}`;
}
